import React from 'react'
import { ChevronDown } from 'lucide-react'
import { Button } from '@/components/ui/button'
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu'
import store from '../../../state/store'

class ReactivateButton extends React.Component {

  onProceed = () => {
    store.emit('enquiry:reactivate', this.props.enquiry_id)
  }

  onCancel = () => {
    store.emit("ui:enquiry:buttons:reactivate", { open: false })
  }

  onEdit = () => {
    store.emit("ui:enquiry:buttons:reactivate", { open: true })
  }

  render() {
    return (
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          {/* secondary, not outline: outline sets no text color, so inside the
              text-white deactivated banner it rendered white-on-white. */}
          <Button variant="secondary" size="sm">Reactivate <ChevronDown className="size-3.5"/></Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end">
          <DropdownMenuItem onSelect={this.onProceed}>Reactivate</DropdownMenuItem>
          <DropdownMenuItem onSelect={this.onCancel}>Cancel</DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
    )
  }
}

export default ReactivateButton
